var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCertificateBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 880,
    height: 700,
    viewBox: "0 0 880 700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 175.472C235.315 186.987 456.709 251.637 652.498 357.708C566.53 461.196 493.852 576.171 437.091 700H178.338L0 521.509V175.472Z",
    fill: "#F4F4F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M539.131 700C588.643 591.984 650.267 490.704 722.259 397.91C777.207 431.528 829.883 468.512 880 508.576V700H539.131Z",
    fill: "#F4F4F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M880 389.422C847.571 367.607 814.267 347 780.15 327.663C811.808 291.476 845.131 256.79 880 223.725V389.422Z",
    fill: "#F4F4F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M711.299 290.929C763.566 234.907 819.961 182.806 880 135.113C880 98.0002 880 30.0003 880 0.000289281C582 0.000289281 48.5 -0.000650883 6.10352e-05 0.000289281C6.86646e-05 32.5009 6.10352e-05 109 6.10352e-05 129.592C8.64005 129.448 17.2974 129.376 25.9715 129.376C272.272 129.376 505.022 187.546 711.299 290.929Z",
    id: "tca-cert-bg_grad-el"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M533.633 700C583.373 587.386 644.398 485.026 719.29 390.338C774.591 424.512 826.8 463.174 880 506.728C880 465 880 426.5 880 385.077C845.835 361.618 813.366 339.985 778.674 320.083C810.834 284.426 843.224 249.846 880 216.19C880 184.5 880 161.5 880 128.019C818.976 175.229 763.526 226.679 710.038 283.077C473.506 163.508 227.164 120.385 1.73074e-05 124.461C1.2698e-05 136.001 1.73074e-05 158.001 1.73074e-05 170.301C232.89 187.45 449.706 241.361 650.204 350.263C565.909 451.138 493.12 566.616 433.654 700C462.5 700 507.5 700 533.633 700Z",
    fill: "#F4F4F4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M529.126 700C579.496 584.227 641.628 479.263 718.29 382.338C773.591 416.512 826.8 455.174 880 498.728C880 457 880 418.5 880 377.077C845.835 353.618 812.366 331.985 777.674 312.083C809.834 276.426 843.224 241.846 880 208.19C880 176.5 880 153.5 880 120.019C818.976 167.229 762.526 218.679 709.038 275.077C472.506 155.508 227.164 112.385 1.73074e-05 116.461C1.2698e-05 128.001 1.73074e-05 150.001 1.73074e-05 162.301C232.89 179.45 448.706 233.361 649.204 342.263C563.229 445.15 489.222 563.227 429.113 700C455 700 506.5 700 529.126 700Z",
    fill: "#F4F4F4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M524.671 700C575.648 581.057 638.866 473.49 717.29 374.337C772.591 408.511 826.8 447.174 880 490.728C880 449 880 410.5 880 369.077C845.835 345.618 811.366 323.985 776.674 304.083C808.834 268.425 843.224 233.846 880 200.189C880 168.5 880 145.499 880 112.019C818.976 159.228 761.526 210.679 708.038 267.076C471.506 147.508 227.164 104.384 1.73074e-05 108.461C1.2698e-05 120 1.73074e-05 142 1.73074e-05 154.3C232.89 171.45 447.706 225.361 648.204 334.262C560.557 439.15 485.348 559.824 424.622 700C464 700 496.5 700 524.671 700Z",
    fill: "#F4F4F4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tca-cert-bg--dev",
    x1: 0.0000582955,
    y1: 216.742,
    x2: 852.084,
    y2: -12.2396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#048467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#064871"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tca-cert-bg--datascience",
    x1: -0.00000273965,
    y1: 216.742,
    x2: 852.083,
    y2: -12.2396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#723390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C384F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tca-cert-bg--design",
    x1: -0.00000273965,
    y1: 216.742,
    x2: 852.083,
    y2: -12.2396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#065D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#06596E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E3B91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tca-cert-bg--qa",
    x1: -0.00000273965,
    y1: 216.742,
    x2: 852.083,
    y2: -12.2396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#363D8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#723390"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tca-cert-bg--default",
    x1: 0.0000121858,
    y1: 290.929,
    x2: 893.056,
    y2: 237.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#048467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "#064871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#6831A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C384D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateBg);
export default __webpack_public_path__ + "static/media/certificate-bg.e3c6d14071d75fc382320063a386438b.svg";
export { ForwardRef as ReactComponent };